/* O que a interface aceita como e-mail.
 *
 * Mora fora das telas porque é a MESMA regra em duas: o contato da empresa e a
 * credencial da conta. Duas cópias do padrão viram duas regras diferentes na
 * primeira vez que alguém afrouxar uma delas.
 *
 * Deliberadamente frouxo: algo antes da arroba, algo depois, e um ponto no
 * domínio. Validar e-mail por regex "completa" (RFC 5322) reprova endereço
 * válido e continua aceitando endereço inexistente. Quem diz se o e-mail é
 * real é o servidor, ao recusar o cadastro. */
const PADRAO = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function emailValido(texto: string): boolean {
  return PADRAO.test(texto.trim());
}
